import React from 'react';
import Select from "react-select";

const BaseMultiSelect = (props) => {
    return (
        <Select {...props}/>
    )
}

export default BaseMultiSelect;